import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem.js";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages.js";
import { AppHelpers } from "../../../hooks/useWidgetInitialization/helpers.js";
import { NavigationUtils, PageContextUtils } from "../../../utils/index.js";
import { UISelectors } from "../../../redux/selectors/index.js";
import { useSelector } from "react-redux";

const InPlayBottomBarNavigationItem = () => {
  const links = useSelector(UISelectors.links);
  const { contentLangId } = PageContextUtils.getLocalizationData();

  const onInPlayClick = () => {
    AppHelpers.toggleBetslipVisibility(false);
    const inPlayURL = getInPlayURL();
    NavigationUtils.navigateTo(inPlayURL);
  };

  const getInPlayURL = () => {
    if (typeof links.liveNow === "string") {
      return links.liveNow;
    }
    if (typeof links.liveNow === "object") {
      return links.liveNow[contentLangId] || links.liveNow.en;
    }
  };

  return (
    <BottomBarNavigationItem
      onClick={onInPlayClick}
      iconColor={"white"}
      iconLabel={"inplay"}
      dataTestId={"bottom-navigation-inplay"}
      googleAnalyticsLabel={"inplay"}
    >
      <FormattedMessage {...LocalizationMessages.bottomNavigationInPlay} />
    </BottomBarNavigationItem>
  );
};

export default React.memo(InPlayBottomBarNavigationItem);

InPlayBottomBarNavigationItem.propTypes = {};
